import { createPromiseClient } from '@connectrpc/connect';
import { AqoraService as Aqora } from '@wavingroup/aqora-v2-api/wavin/aqora/v2/aqora_service_connect';
import { transport } from '~/services/api/service-transport';

export const aqoraClient = createPromiseClient(Aqora, transport);
